import { SearchInput } from '../shared';
import { SortOrder, ERPSortType } from '../enums';

export class GetERPsInput extends SearchInput<ERPSortType> {
    constructor() {
        super(ERPSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}